import Swup from 'swup';
import SwupScrollPlugin from '@swup/scroll-plugin';
import SwupPreloadPlugin from '@swup/preload-plugin';
import SwupBodyClassPlugin from '@swup/body-class-plugin';
import Bulider from './components/bulider';
import Header from './components/header';
import Global from './components/global';


const options = {
    containers: ["#container"],
    debugMode: true,
    plugins: [
        new SwupPreloadPlugin(),
        new SwupBodyClassPlugin(),
        new SwupScrollPlugin({
            doScrollingRightAway: false,
            animateScroll: true,
            scrollFriction: 0.3,
            scrollAcceleration: 0.04
        }),
    ],
}
const swup = new Swup(options);
swup.preloadPages();


function init() {
   // load content
  //  const $form = jQuery('.wpcf7-form').eq(0);
    // console.log(wpcf7cf);
    // console.log(wpcf7);  

    //wpcf7cf.initForm($form);
    // jQuery('div.wpcf7 > form').each(function () {
    //     var $form = $(this);
    //     console.log(wpcf7);
    //     wpcf7.init($form[0]);
    //     if (wpcf7.cached) {
    //         wpcf7.refill($form);
    //     }
    // }); 

    if (window.innerWidth < 991) {
        let glob = new Global(),
            header = document.querySelector('.header');

        header.querySelector('.header__hamburger').classList.remove('active');
        glob.slideUp(header.querySelector('nav'));
        
        
    }

    new Bulider();
   

}
swup.on('contentReplaced', init);

function unload() {}
swup.on('willReplaceContent', unload);

function start(){
    // start content
    new Header();
    init();
}




document.addEventListener('load', start(), false);